import useWbwTranslations from "@/lib/hooks/useWbwTranslation";
import { useMemo } from "react";
import { amiri, indoPak } from "@/app/fonts";
import { useQuranOptions } from "@/app/providers/QuranContextProvider";
import { Spinner } from "./spinner";

export default function QuranWbwTranslations({
  wordId,
  page,
}: {
  wordId: number;
  page: number;
}) {
  const { wordTranslation } = useWbwTranslations(wordId, page);
  const { quranMushaf } = useQuranOptions();

  const wbwTranslation = useMemo(() => {
    return (
      <div className="">
        <div
          className={`${
            quranMushaf.type == "indopak15" || quranMushaf.type == "indopak16"
              ? wordTranslation?.root
                ? indoPak.className
                : amiri.className
              : amiri.className
          } text-md text-text leading-10`}
        >
          {wordTranslation?.root ? wordTranslation.root : "—"}
        </div>
        <div className="text-text">{wordTranslation?.translation}</div>
      </div>
    );
  }, [wordTranslation, quranMushaf]);

  return (
    <>
      {!wordTranslation ? (
        <Spinner className="text-primary" size={"small"}>
          <span>Loading......</span>
        </Spinner>
      ) : (
        wbwTranslation
      )}
    </>
  );
}
